/**
 * ShreemTech Universal Admin Panel
 * Copyright (c) 2026 ShreemTech Ltd. All Rights Reserved.
 * PROPRIETARY AND CONFIDENTIAL — TRADE SECRET
 */

import { MOCK_MODE } from "./config";
import { mockAuthClient } from "./mocks/auth-mock";
import { realAuthClient } from "./real/auth-real";

export type { LoginParams, AuthResult } from "./mocks/auth-mock";

export const authClient = MOCK_MODE ? mockAuthClient : realAuthClient;
